export default __webpack_public_path__ + "static/media/bN.278ba730.svg";